"use client";

import { useState } from "react";
import { DropZone } from "@/components/DropZone";
import { FileStrip } from "@/components/FileStrip";
import { ToolCard } from "@/components/ToolCard";
import { ALL_KINDS, MAX_BATCH_FILES } from "@/lib/files";
import { handOffFiles } from "@/lib/handoff";
import { toolsForFiles } from "@/lib/tools";

/** Hero drop zone: takes any PDF or image, then suggests the tools that can
 *  open it. Picking one carries the files over in memory (nothing is uploaded). */
export function HomeDropZone() {
  const [files, setFiles] = useState<File[]>([]);
  const suggestions = toolsForFiles(files);

  return (
    <div className="rounded-[20px] bg-card p-3 shadow-[0_1px_0_#e6e9f2] sm:p-4">
      {files.length === 0 ? (
        <DropZone
          accepts={ALL_KINDS}
          maxFiles={MAX_BATCH_FILES}
          onFiles={setFiles}
          title="Drop a PDF or image here"
          subtitle="We'll suggest what you can do with it."
        />
      ) : (
        <div className="flex flex-col gap-4 p-2 sm:p-3">
          <h2 className="text-2xl">What would you like to do?</h2>
          <FileStrip
            files={files}
            onRemove={(i) => setFiles(files.filter((_, j) => j !== i))}
          />
          {suggestions.length > 0 ? (
            <ul aria-label="Suggested tools" className="grid gap-2">
              {suggestions.map((tool) => (
                <li key={tool.slug} className="grid">
                  <ToolCard tool={tool} onClick={() => handOffFiles(files)} />
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-ink">
              No single tool takes this mix of files. Try PDFs or images on
              their own.
            </p>
          )}
          <button
            type="button"
            onClick={() => setFiles([])}
            className="min-h-11 self-start rounded-lg border-[1.5px] border-ink px-4 font-semibold hover:bg-sand"
          >
            Choose different files
          </button>
        </div>
      )}
    </div>
  );
}
